import React from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';
import clsx from '@strava/ui/clsx';
import LogosFacebookSmall from '@strava/icons/LogosFacebookSmall';
import styles from './LinkFacebookButton.scss';

const LinkFacebookButton = ({ children, onClick, fullWidth, className }) => (
  <Button
    type="button"
    onClick={onClick}
    className={clsx(
      styles.facebookButton,
      fullWidth && styles.fullWidth,
      className
    )}
    variant="primary"
    data-cy="fb-connect-btn"
  >
    <LogosFacebookSmall />
    {children}
  </Button>
);

LinkFacebookButton.defaultProps = {
  className: null,
  fullWidth: false
};

LinkFacebookButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool
};

export default LinkFacebookButton;
